import React from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = React.createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = React.useState(() => localStorage.getItem("gl_lang") || "pt");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("gl_lang", l);
    document.documentElement.lang = l === "pt" ? "pt-PT" : "en";
  };

  React.useEffect(() => {
    document.documentElement.lang = lang === "pt" ? "pt-PT" : "en";
  }, [lang]);

  const t = React.useCallback(
    (key, vars) => {
      const dict = translations[lang] || translations.pt;
      let str = dict[key] !== undefined ? dict[key] : (translations.pt[key] ?? key);
      if (vars) {
        Object.keys(vars).forEach((k) => {
          str = str.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
        });
      }
      return str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = React.useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

export const useT = () => useLang().t;
